
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 41 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.939 40H9.06C4.341 40 .5 36.159.5 31.439V8.56C.5 3.841 4.341 0 9.061 0H31.94c4.72 0 8.561 3.841 8.561 8.561V31.44c0 4.72-3.841 8.561-8.561 8.561zM9.06 1.557A7.012 7.012 0 002.057 8.56V31.44a7.012 7.012 0 007.004 7.004H31.94a7.012 7.012 0 007.004-7.004V8.56a7.012 7.012 0 00-7.004-7.004H9.06z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.535 29.86l-7.767-11.062a.136.136 0 01.009-.167l6.993-7.955a.401.401 0 00.065-.436.402.402 0 00-.37-.24h-1.063a.407.407 0 00-.306.139l-6.23 7.086a.134.134 0 01-.101.046.135.135 0 01-.112-.058l-4.943-7.04a.407.407 0 00-.333-.172h-5.36a.406.406 0 00-.333.642l7.474 10.643a.136.136 0 01-.009.168l-7.36 8.371a.401.401 0 00-.065.437c.067.148.21.24.371.24h1.062c.118 0 .229-.05.306-.14l6.597-7.502a.135.135 0 01.213.012l5.236 7.456c.076.109.2.173.333.173h5.36a.406.406 0 00.333-.642zM13.33 11.66a.133.133 0 01.12-.074h2.074c.044 0 .085.021.11.057l12.23 17.117c.03.042.034.095.01.141a.133.133 0 01-.12.074H25.68a.136.136 0 01-.111-.057L13.339 11.8a.134.134 0 01-.01-.141z","fill":"#fff"}})])
          )
        }
      }
    